import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { jsx as _jsx } from "react/jsx-runtime";
const ContentTablePaginator = ({
  page,
  pageCount,
  onPaginate
}) => {
  const handlePaginateClick = event => {
    const nextPage = event.target.value;
    if (page !== nextPage) {
      onPaginate(nextPage);
    }
  };
  return /*#__PURE__*/_jsx(Paginator, {
    marginBlockStart: "400",
    onPageChange: handlePaginateClick,
    page: page,
    pageCount: pageCount,
    showFirstLastButtons: true,
    maxVisiblePageButtons: 7
  });
};
export default ContentTablePaginator;